<template>
  <div class="content">
    <div class="notice">
      <p>小程序内关注公众号组件，新用户通过手机扫码时展现，已关注公众号用户，展示为查看，退出小程序后，再次进入不再展现</p>
    </div>
    <div class="set_wrap whd-set-wrap">
      <el-tabs v-model="activeName" tab-position="left">
        <!-- <el-tab-pane label="配置组件" disabled name="first"></el-tab-pane> -->
        <el-tab-pane label="名片页配置组件" name="first">
          <div class="config_flexwrap">
            <div class="config_flex">
              <div class="config_preview official_preview">
                <!-- <img class="config_img" src="/static/img/official-img.png" alt > -->
                <img class="config_img" src="@/assets/imgs/small.png" alt >
                <div v-if="guide_checked" class="official_preview_dialog">
                  <p class="official_preview_dialog_title mb-10">微信企业号关联的公众号</p>
                  <div class="official_preview_dialog_body">
                    <div class="official_preview_dialog_body_left mr-10">
                      <!-- <img src="/static/img/companyimg.png" alt=""> -->
                      <img src="@/assets/imgs/zxicon.png" alt="">
                    </div>
                    <div class="official_preview_dialog_body_center">
                      <p class="official_preview_title">企业名称</p>
                      <p class="official_preview_titlea">全心全意，为您服务</p>
                    </div>
                    <div class="official_preview_dialog_body_right">
                      <span>关注</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="config_item">
              <div class="config_top">操作</div>
              <div class="config_con">
                <p class="mb-20">
                  <el-checkbox v-model="guide_checked">名片页底部设置</el-checkbox>
                </p>
                <el-button type="primary" @click="submitLine" size="small">发布</el-button>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
  import api from "@/api.js";

  export default {
    name: "analyticsOfficialFocus",
    data() {
      return {
        activeName: "first",
        guide_checked: '',
        guide_checked_old: ''
      };
    },
    created() {
      this.InitFn()
    },
    methods: {
      InitFn() {
        this.axios
            .post(api.accounts_guide, {})
            .then(response => {
              if (response.data.code == 0) {
                // "开关(0关闭、1开启)"
                let switch_guide = false
                if (Number(response.data.info.switch_guide) === 1) {
                  switch_guide = true
                }
                this.guide_checked = switch_guide
                this.guide_checked_old = response.data.info.switch_guide
              } else {
              }
            })
            .catch(response => {
            });
      },
      submitLine() {
        //console.log(this.guide_checked)
        // switch_guide: '' // 开关(0关闭、1开启)
        let switch_guide = 0
        if(this.guide_checked){
          switch_guide = 1
        }
        if(Number(this.guide_checked_old) === switch_guide){
          this.$message({
            message: '未改变设置',
            center: true,
            type: 'warning'
          });
          return
        }
        this.axios
            .post(api.accounts_guide_set, {switch_guide: switch_guide})
            .then(response => {
              if (response.data.code == 0) {
                this.$message({
                  message: '设置成功',
                  center: true,
                });
              } else {
              }
            })
            .catch(response => {
            });
      },
      searchName() {
        this.form.page = 1
        this.InitFn()
      }
    }
  };
</script>
